// Tab «Команда» of an event (ЭС8, R-A4): who works on this event — people whose roles reach it (limited to it or to all events)
// and the event's programme committee. The binding to the event is a property of the grant, so the list is derived, not typed in.
import { grantLive } from '@confdeck/core-shared';
import { Avatar, LinkedTable, useMeta, useSync } from '@confdeck/core-web';
import s from './conferences.module.css';

export function EventTeam({ recordId }: { recordId: string }) {
  const meta = useMeta();
  const client = useSync();
  const me = meta.user(client.header?.userId);
  // Colleagues' grants come to the owner and «Администратор» only (teamView); others see the committee.
  const people = meta.users().filter((u) => !u.archivedAt).map((u) => {
    if (u.role === 'owner') return { u, roles: ['Владелец аккаунта — все события'] };
    const roles = (u.grants ?? []).filter((g) => grantLive(g) && (!g.scopeIds || g.scopeIds.includes(recordId)))
      .map((g) => `${meta.role(g.roleId)?.name ?? 'Роль'}${g.scopeIds ? '' : ' — все события'}`);
    return { u, roles };
  }).filter((x) => x.roles.length);
  const seesGrants = me?.role === 'owner' || (me?.grants ?? []).some((g) => grantLive(g) && meta.role(g.roleId)?.full && !g.scopeIds);
  return (
    <>
      <section className={s.team}>
        <h3 className={s.tplHead}>Работают на событии</h3>
        {seesGrants ? (people.length ? people.map(({ u, roles }) => (
          <div key={u.id} className={s.teamRow}><Avatar name={u.name} color={u.color} size={20} /><span className={s.teamName}>{u.name}</span><span className={s.tplHint}>{roles.join(', ')}</span></div>
        )) : <p className={s.tplHint}>Ролей с этим событием ни у кого нет.</p>) : <p className={s.tplHint}>Состав команды видит владелец и «Администратор».</p>}
        <p className={s.tplHint}>Роль привязывают к событию при выдаче: «Команда → Люди → Роли → Событие».</p>
      </section>
      <LinkedTable recordId={recordId} field="pc_members" optional title="Программный комитет" columns={['title', 'user', 'contact', 'role', 'rights', 'categories']} empty="Состав ПК не задан" />
    </>
  );
}
